<div *ngIf="isLoggedIn" class="app-header">

    <div class="float-left icici-logo flex-container">
        <div class="d-sm-block d-md-none">
            <div class="for-mobi-menu">
                <a>
                    <img src="assets/images/hamburger.svg" alt="Menu">
                </a>
            </div>
        </div>
        <div class="for-logo">
            <a>
                <img src="assets/images/cp_app_logo.png" alt="Logo">
            </a>
        </div>
    </div>
    
    <div class="d-none d-sm-none d-md-block">
        <app-logout-modal></app-logout-modal>
    </div>

</div>
<app-ie-banner></app-ie-banner>